import { type SalesOrder, SortingOrder } from "@/graphql/codegen/graphql"

export const sortSalesOrdersByShippedDate = (salesOrders: SalesOrder[], order: SortingOrder): SalesOrder[] =>
  [...salesOrders].sort((a, b) => {
    if (!a.warehouseShippedOn && !b.warehouseShippedOn) return 0
    if (!a.warehouseShippedOn) return 1
    if (!b.warehouseShippedOn) return -1

    const comparison = a.warehouseShippedOn.localeCompare(b.warehouseShippedOn)
    return order === SortingOrder.Desc ? -comparison : comparison
  })

export const sortSalesOrdersByDeliveryDate = (salesOrders: SalesOrder[], order: SortingOrder): SalesOrder[] =>
  [...salesOrders].sort((a, b) => {
    const comparison = a.deliveryDate.localeCompare(b.deliveryDate)
    return order === SortingOrder.Desc ? -comparison : comparison
  })

export const filterSalesOrdersByQuery = (salesOrders: SalesOrder[], query?: string): SalesOrder[] => {
  const normalizedQuery = query?.trim().toLowerCase()
  if (!normalizedQuery) return salesOrders

  return salesOrders.filter(
    (salesOrder) =>
      salesOrder.publicId.toLowerCase().includes(normalizedQuery) ||
      salesOrder.cpoNumbers.some((cpoNumber) => cpoNumber.toLowerCase().includes(normalizedQuery))
  )
}
